export const STORAGE_KEY = 'accounts_nudge_impressions';
export const SESSION_KEY = 'accounts_nudge_shown';